import { apiPost } from "./api";

// FPL Sync Functions
export function syncBootstrap(options = {}) {
  return apiPost("/FplSync/bootstrap", undefined, options);
}

export function syncFixtures(options = {}) {
  return apiPost("/FplSync/fixtures", undefined, options);
}

export function fullSync(options = {}) {
  return apiPost("/FplSync/all", undefined, options);
}

export function rebuildScores(options = {}) {
  return apiPost("/Scoring/rebuild", undefined, options);
}

// World Cup Sync Functions
export function wcSyncBootstrap(season = 2026, options = {}) {
  return apiPost(`/WcSync/bootstrap?season=${season}`, undefined, options);
}

export function wcSyncFixtures(season = 2026, options = {}) {
  return apiPost(`/WcSync/fixtures?season=${season}`, undefined, options);
}

export function wcFullSync(season = 2026, options = {}) {
  return apiPost(`/WcSync/full?season=${season}`, undefined, options);
}
